module.exports = __webpack_public_path__ + "static/git-rebase-v-merge-7-62bef3f2bd95c3d05531728b71a00a25.png";